import dayjs from 'dayjs';
import { FC, useEffect, useState } from 'react';
import { InlineInputs } from '../../components/inline-inputs/inline-inputs';
import { formatRuTimeString, formatToFrontendDate } from '../../helpers/date-time';
import { useLang } from '../../hooks/use-lang';
import { DatePicker } from './date-picker/date-picker';
import { TimePicker } from './time-picker/time-picker';

interface Props {
  onChange: (dateTime?: Date) => void;
  value?: string;
  minDate?: Date;
  maxDate?: Date;
  name?: string;
  disabled?: boolean;
}

export const DateTime: FC<Props> = (props) => {
  const { t } = useLang();
  const { onChange, maxDate, minDate, name, value, disabled } = props;
  const [selectedDate, setSelectedDate] = useState<Date>();
  const [selectedTime, setSelectedTime] = useState<string>('');

  useEffect(() => {
    if (value) {
      const frontDate = formatToFrontendDate(value);
      setSelectedDate(frontDate);
      const frontTime = formatRuTimeString(value);
      setSelectedTime(frontTime);
    } else {
      setSelectedDate(undefined);
      setSelectedTime('');
    }
  }, [value]);

  const handleChangeDate = (date?: Date) => {
    if (!date) {
      setSelectedDate(undefined);
      setSelectedTime('');
      onChange(undefined);
      return;
    }
    setSelectedDate(date);
    const [hours = 0, minutes = 0] = selectedTime.split(':').map(Number);
    const combinedDateTime = new Date(date);
    combinedDateTime.setHours(hours, minutes);
    setSelectedTime(`${hours || '00'}:${minutes || '00'}`);
    dayjs(combinedDateTime).isValid() && onChange(combinedDateTime);
  };

  const handleChangeTime = (time: string) => {
    setSelectedTime(time);
    const [hours, minutes] = time.split(':').map((item) => item.replace('__', ''));
    const combinedDateTime = selectedDate ? new Date(selectedDate) : new Date();
    if (hours && minutes && hours.length === 2 && minutes.length === 2) {
      combinedDateTime.setHours(Number(hours), Number(minutes));
    }

    if (!hours || !minutes || (hours.length === 0 && minutes.length === 0)) {
      combinedDateTime.setHours(0, 0, 0);
    }

    dayjs(combinedDateTime).isValid() && onChange(combinedDateTime);
  };

  return (
    <InlineInputs disabled={disabled}>
      <DatePicker
        onSelectDate={handleChangeDate}
        selectedDate={selectedDate}
        placeholder={t('Дата')}
        maxDate={maxDate}
        minDate={minDate}
        name={name ? `${name}-date` : undefined}
      />
      <TimePicker
        onChange={handleChangeTime}
        value={selectedTime}
        name={name ? `${name}-time` : undefined}
        disabled={!selectedDate}
      />
    </InlineInputs>
  );
};
